/* eslint-disable import/no-cycle */
import { BaseURL } from '../config';
import {
  getCartListenerSelectorsObjectUtils,
  getOfferPerformanceEndpointUtils,
} from '../index-utils';

function getBaseURL() {
  return BaseURL;
}

export function getShopConfigEndpoint() {
  return `${getBaseURL()}/app/shop/config`;
}

export function getShopProductIDEndpoint() {
  return `${getBaseURL()}/app/product`;
}

export function getOfferEndpoint() {
  return `${getBaseURL()}/app/offer`;
}

export function getOfferPreviewEndpoint() {
  return `${getBaseURL()}/app/offer/preview`;
}

export function getSubscriptionEndpoint() {
  return `${getBaseURL()}/app/offer/subscription`;
}

export function getCheckoutEndpoint() {
  return `${getBaseURL()}/app/checkout`;
}

export function getCartDiscountEndpoint() {
  return `${getBaseURL()}/app/offer/mrcart`;
}

export function getOfferViewEndpoint() {
  return `${getBaseURL()}/app/offer/view`;
}

export function getOfferPerformanceEndpoint() {
  return getOfferPerformanceEndpointUtils();
}

export function getSubscriptionViewEndPoint() {
  return `${getBaseURL()}/app/subscription/view`;
}

export function getCartListenerSelectorsObject({
  cartPageListenerSelector,
  cartPageListenerFunction,
  cartDrawerListenerSelector,
  cartDrawerListenerFunction,
  cartCountListenerSelector,
  cartCountListenerFunction,
}) {
  return getCartListenerSelectorsObjectUtils({
    cartPageListenerSelector,
    cartPageListenerFunction,
    cartDrawerListenerSelector,
    cartDrawerListenerFunction,
    cartCountListenerSelector,
    cartCountListenerFunction,
  });
}

export const sectionsToUpdateHtml = ['cartPage', 'cartDrawer', 'cartCount'];

export const freeGiftlocalStorageTTL = 1000 * 60 * 60 * 24 * 3;

export const productAddonLayouts = ['checkbox', 'tiles'];
